// src/components/OffersSwiper.js
import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { slides } from '../data/offers';
import 'swiper/css';

export default function OffersSwiper({ activeId }) {
  // activeId is like "content3" → we strip "content" to get the slide id
  const activeSlideId = activeId.replace('content', '');

  return (
    <div className="swiper-container moving-for-everyone-slider">
      <Swiper slidesPerView="auto" spaceBetween={32} loop>
        {slides.map((s) => (
          <SwiperSlide
            key={s.id}
            className="swiper-slide swiperslidehighlights"
            style={{ width: '264px', marginRight: '64px' }}
          >
            <a
              href={s.link}
              target="_blank"
              rel="noopener"
              className="image-block rounded"
              style={{ paddingTop: '117%' }}
            >
              <img
                src={s.bgImage}
                alt=""
                className="image-block-image imageblockimage"
                width="812"
                height="864"
              />
              {String(s.id) === activeSlideId && (
                <div className="image-block-inner">
                  <div className="item-inner is-hidden-tablet-only is-hidden-desktop-only">
                    <h3 className={s.titleClass}>{s.label}</h3>
                    <span className={s.subtitleClass}>{s.subtitle}</span>
                  </div>
                  <a
                    href={s.link}
                    target="_blank"
                    rel="noopener"
                    className="item-outside-text is-hidden-mobile is-hidden-widescreen"
                  >
                    <h3 className={s.titleClass}>{s.label}</h3>
                    <span className={s.subtitleClass}>{s.subtitle}</span>
                  </a>
                </div>
              )}
            </a>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}
